import { Pagination } from '../../../../../models/Pagination';
import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { ErrorResponse, globalErrorResponse } from '../../../../store/notifications/actions';
import { ReserveActionValue } from '../../../../store/reserve/actions';
import { includeOrExcludeFilter } from './apiIncludeOrExcludeFilter';
import { invalidateReserveReportSummary } from '../reserve-list/useReserveReportSummary';
import {
    invalidateReserveReportProducts,
    updateAcceptedStateOfProducts
} from '../reserve-list/useReserveReportProducts';
import { useProductFilters } from '../../../../shared/filter/useProductFilters';
import { RESERVE_ACCEPT_ACTION_VALUE } from '../../constants';

export function useFilterAcceptReject(reserveListId: string, pagination: Pagination) {
    const dispatch = useDispatch();
    const { filters } = useProductFilters();

    return useMutation<void, ErrorResponse, ReserveActionValue>(
        (action: ReserveActionValue) => {
            updateAcceptedStateOfProducts(reserveListId, action === RESERVE_ACCEPT_ACTION_VALUE);
            return includeOrExcludeFilter(reserveListId, { action, filters, pagination });
        },
        {
            onSuccess: () => {
                invalidateReserveReportSummary(reserveListId).then();
                invalidateReserveReportProducts(reserveListId).then();
            },
            onError: error => {
                invalidateReserveReportProducts(reserveListId).then();
                dispatch(globalErrorResponse(error));
            }
        }
    );
}
